module.exports = __webpack_public_path__ + "static/media/minus.69b30251.svg";